function runH1FadeIn(wrapper) {
  const chars = wrapper.innerText.split('');

  // Clear h1 wrapper from current elements
  while (wrapper.firstChild) {
    wrapper.removeChild(wrapper.firstChild);
  }

  // Create spans for each character and add necessary styles
  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < chars.length; i++) {
    const span = document.createElement('span');
    span.style.opacity = 0;
    span.style.marginLeft = '0.5%';
    span.style.marginRight = '0.5%';
    span.innerText = chars[i];
    span.classList.add('h1-transition');
    wrapper.appendChild(span);
  }

  // Add animation class to characters with delay between each iteration
  setTimeout(() => {
    [...wrapper.childNodes].forEach((c, i) => {
      setTimeout(() => {
        // eslint-disable-next-line no-param-reassign
        c.style.marginLeft = '0%';
        // eslint-disable-next-line no-param-reassign
        c.style.marginRight = '0%';
        // eslint-disable-next-line no-param-reassign
        c.style.opacity = '1';
      }, i * 50);
    });
  }, 1000);

  setTimeout(() => {
    const heroButton = document.querySelector('.brix-hero > .content > .button');
    heroButton.style.opacity = 1;
  }, 3000);
}

export default runH1FadeIn;
